module.exports = __webpack_public_path__ + "static/media/Overview.3db7a8c0.svg";